import React from 'react';
import { Info, Lightbulb, AlertTriangle, ShieldCheck } from 'lucide-react';

/**
 * Four callout variants. `admin` matters more than it looks — product docs
 * constantly need "not everyone can do this", and a consistent badge beats a
 * paragraph of prose every time.
 */
const VARIANTS = {
  note:    { icon: Info,        label: 'Note',       bg: 'bg-blue-50',   border: 'border-blue-200',   text: 'text-blue-900',   icon_c: 'text-blue-600' },
  tip:     { icon: Lightbulb,   label: 'Tip',        bg: 'bg-green-50',  border: 'border-green-200',  text: 'text-green-900',  icon_c: 'text-green-600' },
  warning: { icon: AlertTriangle, label: 'Careful',  bg: 'bg-amber-50',  border: 'border-amber-200',  text: 'text-amber-900',  icon_c: 'text-amber-600' },
  admin:   { icon: ShieldCheck, label: 'Admin only', bg: 'bg-slate-50',  border: 'border-slate-300',  text: 'text-slate-800',  icon_c: 'text-slate-600' },
};

const Callout = ({ type = 'note', title, children }) => {
  const v = VARIANTS[type] || VARIANTS.note;
  const Icon = v.icon;
  return (
    <div className={`not-prose my-5 flex gap-3 rounded-xl border ${v.bg} ${v.border} p-4`}>
      <Icon className={`w-5 h-5 flex-shrink-0 mt-0.5 ${v.icon_c}`} />
      <div className={`text-sm leading-relaxed ${v.text}`}>
        <p className="font-semibold mb-0.5">{title || v.label}</p>
        <div>{children}</div>
      </div>
    </div>
  );
};

export default Callout;
